import { Filters, managePageFilters } from '../../../utils/urlUtil'
import { FilterValuesData } from '../filters'
import React, { useEffect, useState } from 'react'
import { Checkbox, Input } from 'semantic-ui-react'
import { MagnifyingGlass as SvgMagnifyingGlass } from 'phosphor-react'
import { useIntl } from 'react-intl'

interface IProps {
  filterPage: string
  filters: Filters
  filterOptions: string[]
  filterKey: string
  filterTitleI18NId: string
  filterOptionsData?: FilterValuesData[]
  isSorted?: boolean
  closeFilters?: () => void
  changeFunction?: (key: string, setValue?: string) => void
}

const ToggleFilter = (props: IProps): React.ReactElement => {
  const {
    filterPage,
    filters,
    filterOptions,
    filterKey,
    filterTitleI18NId,
    filterOptionsData = [],
    isSorted = true,
    closeFilters,
    changeFunction
  } = props

  const intl = useIntl()

  const currentFilter = filters[filterKey] || ''

  const [options, setOptions] = useState<string[]>([])
  const [searchSubClass, setSearchSubClass] = useState('')

  useEffect(() => setOptions(filterOptions), [filterOptions])

  const handleChangeSubClass = (_, data) => {
    const isUnCheck = currentFilter.includes(data.value)
    changeFunction &&
      (isUnCheck ? changeFunction(filterKey) : changeFunction(filterKey, data.value))
    managePageFilters({
      pageName: filterPage,
      filterKey,
      filterValues: [data.value],
      action: isUnCheck ? 'remove' : 'add',
      toggle: true
    })
    closeFilters && closeFilters()
  }

  const handleSearchSubClass = (_, { value }) => {
    setSearchSubClass(value)
    const valLower = value.toLowerCase()
    setOptions(filterOptions.filter((option) => option.toLowerCase().includes(valLower)))
  }

  const listSorted = !isSorted ? options : [...options].sort((a, b) => a.localeCompare(b))

  if (!listSorted.length && !searchSubClass.length) return <></>
  const searchPlaceholder = intl.formatMessage({ id: filterTitleI18NId })

  return (
    <div className="column" data-test-id="filters-toggle-filter">
      <div className="title">
        <Input
          value={searchSubClass}
          onChange={handleSearchSubClass}
          placeholder={searchPlaceholder}
          input={{ className: 'truncate', title: searchPlaceholder }}
          icon={
            <div className="icon-container">
              <SvgMagnifyingGlass size={20} color="var(--color-river-bed)" />
            </div>
          }
        />
      </div>
      <div className="filters-list custom-scrollbar">
        {listSorted.map((option = '', i) => {
          const text = filterOptionsData.find((name) => name.key === option)?.name || option
          return (
            <Checkbox
              key={i}
              value={option}
              checked={currentFilter.includes(option)}
              label={{
                children: (
                  <div className="truncate" title={text}>
                    {text}
                  </div>
                )
              }}
              onChange={handleChangeSubClass}
              title={option}
            />
          )
        })}
      </div>
    </div>
  )
}

export default ToggleFilter
